import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext(null);

const isMobileViewport = () =>
  typeof window !== 'undefined' && window.innerWidth <= 991;

export function SidebarProvider({ children }) {
  // Default: collapsed on mobile, expanded on desktop.
  const [collapsed, setCollapsed] = useState(isMobileViewport);

  // React to viewport changes only when crossing the 991px boundary so we
  // don't override the user's manual collapse/expand on minor resizes.
  useEffect(() => {
    let wasMobile = isMobileViewport();
    const onResize = () => {
      const isMobile = isMobileViewport();
      if (isMobile !== wasMobile) {
        setCollapsed(isMobile);
        wasMobile = isMobile;
      }
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const toggle = () => setCollapsed((c) => !c);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed, toggle }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const ctx = useContext(SidebarContext);
  if (!ctx) {
    throw new Error('useSidebar must be used within <SidebarProvider>');
  }
  return ctx;
}
